export class BreedingMethodGroup {
    constructor(
        public code?: string,
        public name?: string
    ) {
    }
}
